(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 767px)";

  class HeroResponsiveVideo {
    constructor(element) {
      this.hero = element;
      this.desktopVideo = this.hero.querySelector(
        '.hero-slideshow__video[data-hero-viewport="desktop"]'
      );
      this.mobileVideo = this.hero.querySelector(
        '.hero-slideshow__video[data-hero-viewport="mobile"]'
      );
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.activeVideo = null;

      if (!this.desktopVideo && !this.mobileVideo) {
        return;
      }

      this.init();
    }

    showFallback() {
      this.hero.classList.add("hero-slideshow--fallback-active");
      this.hero.classList.remove("hero-slideshow--video-ready");
    }

    showVideo() {
      this.hero.classList.add("hero-slideshow--video-ready");
      this.hero.classList.remove("hero-slideshow--fallback-active");
    }

    getTargetVideo() {
      if (this.mediaQuery.matches) {
        return this.mobileVideo || this.desktopVideo;
      }
      return this.desktopVideo || this.mobileVideo;
    }

    prepareVideo(video) {
      if (!video) {
        return;
      }
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("muted", "");
      video.setAttribute("loop", "");
    }

    playActive() {
      var nextVideo = this.getTargetVideo();
      if (!nextVideo) {
        return;
      }

      [this.desktopVideo, this.mobileVideo].forEach(function (video) {
        if (!video) {
          return;
        }
        var isActive = video === nextVideo;
        video.classList.toggle("hero-slideshow__video--active", isActive);
        video.setAttribute("aria-hidden", isActive ? "false" : "true");
        if (!isActive) {
          video.pause();
        }
      });

      this.activeVideo = nextVideo;
      this.prepareVideo(nextVideo);

      var self = this;
      var playback = nextVideo.play();
      if (playback && typeof playback.then === "function") {
        playback
          .then(function () {
            self.showVideo();
          })
          .catch(function () {
            if (self.activeVideo === nextVideo) {
              self.showFallback();
            }
          });
      } else if (!nextVideo.paused) {
        this.showVideo();
      }
    }

    init() {
      if (this.hero.dataset.heroResponsiveVideoReady === "true") {
        return;
      }
      this.hero.dataset.heroResponsiveVideoReady = "true";
      this.showFallback();

      this.prepareVideo(this.desktopVideo);
      this.prepareVideo(this.mobileVideo);

      var self = this;
      [this.desktopVideo, this.mobileVideo].forEach(function (video) {
        if (!video) {
          return;
        }
        video.addEventListener("playing", function () {
          if (self.activeVideo === video) {
            self.showVideo();
          }
        });
        video.addEventListener("error", function () {
          if (self.activeVideo === video) {
            self.showFallback();
          }
        });
      });

      var onChange = function () {
        self.playActive();
      };

      if (typeof this.mediaQuery.addEventListener === "function") {
        this.mediaQuery.addEventListener("change", onChange);
      } else if (typeof this.mediaQuery.addListener === "function") {
        this.mediaQuery.addListener(onChange);
      }

      this.playActive();
    }
  }

  function initHeroComponents() {
    document.querySelectorAll(".hero-slideshow").forEach(function (hero) {
      new HeroResponsiveVideo(hero);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroComponents);
  } else {
    initHeroComponents();
  }
})();
